import imgI from "../../assets/img/our-approach/focusimg1.png";
import imgII from "../../assets/img/our-approach/focusimg2.png";
import imgIII from "../../assets/img/our-approach/focusimg3.png";
import imgIV from "../../assets/img/our-approach/focusimg4.png";
import imgV from "../../assets/img/our-approach/focusimg5.png";
import imgVI from "../../assets/img/our-approach/focusimg6.png";
import imgVII from "../../assets/img/our-approach/focusimg7.png";
import imgVIII from "../../assets/img/our-approach/focusimg8.png";
import imgIX from "../../assets/img/our-approach/focusimg9.png";

const FocusScope = () => {
	return (
		<section className='bg-[#FFFCF7]'>
			<div className='max-w-[1440px] w-[90%] mx-auto py-16 space-y-16'>
				<div className='space-y-5'>
					<h2 className='md:text-5xl/[69px] text-3xl/10 font-bold'>
						PROGRAM FOCUS AND SCOPE
					</h2>
					<p>
						Synergy Care Foundation has organized its strategic interventions
						into eight primary service categories, each designed to address the
						specific needs of the underserved populations we serve.
					</p>
					<img src={imgI} alt='Our Focus' className='w-full rounded-[30px]' />
				</div>
				<div className='space-y-5'>
					<h5 className='text-4xl/[78px] font-nedium tracking-[-3px]'>
						Healthcare and Mental Health Access
					</h5>
					<p>
						Establish a structured referral system to connect individuals with
						primary care physicians, specialists, and hospitals. Forge
						partnerships with licensed mental health providers to deliver
						therapy, counseling, and crisis intervention services. Provide
						referrals to rehabilitation programs for substance abuse, assist
						with enrollment in Medicaid, Medicare, and ACA programs, and
						facilitate free or low-cost health screenings for conditions such as
						high blood pressure, diabetes, and HIV/AIDS. Additionally, support
						telehealth and virtual consultations to extend the reach of both
						medical and mental health services.
					</p>
					<img src={imgII} alt='Our Focus' className='w-full rounded-[30px]' />
				</div>
				<div className='space-y-5'>
					<h5 className='text-4xl/[78px] font-nedium tracking-[-3px]'>
						Social Services and Public Benefits Access
					</h5>
					<p>
						Offer comprehensive support for government assistance enrollment and
						navigation, assisting individuals in accessing SNAP, TANF, SSI,
						SSDI, and other state and federal benefits. Guide beneficiaries in
						connecting with local aid programs and provide referrals for pro
						bono legal assistance in areas such as civil rights, housing, and
						public benefits. Provide specialized support for seniors and
						individuals with disabilities.
					</p>
					<img src={imgIII} alt='Our Focus' className='w-full rounded-[30px]' />
				</div>
				<div className='space-y-5'>
					<h5 className='text-4xl/[78px] font-nedium tracking-[-3px]'>
						Housing and Shelter Assistance
					</h5>
					<p>
						Facilitate referrals to temporary and emergency housing solutions,
						including shelters and transitional housing programs, and connect
						individuals with affordable housing resources. Offer guidance on
						rental and eviction prevention, support transitional housing
						initiatives for formerly incarcerated individuals, and provide
						referrals for utility assistance to help families manage essential
						bills for electricity, water, and heating.
					</p>
					<img src={imgIV} alt='Our Focus' className='w-full rounded-[30px]' />
				</div>
				<div className='space-y-5'>
					<h5 className='text-4xl/[78px] font-nedium tracking-[-3px]'>
						Basic Needs Support
					</h5>
					<p>
						Operate food pantries and meal programs to supply emergency food and
						hot meals, distribute clothing and hygiene essentials (including
						warm clothing, hygiene kits, and baby supplies), and provide
						transportation assistance through bus vouchers, rideshare credits,
						and public transport passes.
					</p>
					<img src={imgV} alt='Our Focus' className='w-full rounded-[30px]' />
				</div>
				<div className='space-y-5'>
					<h5 className='text-4xl/[78px] font-nedium tracking-[-3px]'>
						Employment and Workforce Development
					</h5>
					<p>
						Facilitate job placement and career counseling services,
						complemented by workshops on resume writing and interview
						preparation. Offer vocational and technical skills training in
						fields such as information technology, construction, healthcare, and
						hospitality. Support entrepreneurship and business start-up
						initiatives, prioritizing employment support for formerly
						incarcerated individuals by connecting them with job opportunities
						and skill-building programs.
					</p>
					<img src={imgVI} alt='Our Focus' className='w-full rounded-[30px]' />
				</div>
				<div className='space-y-5'>
					<h5 className='text-4xl/[78px] font-nedium tracking-[-3px]'>
						Financial Literacy and Economic Empowerment
					</h5>
					<p>
						Enhance economic stability through workshops on budgeting, financial
						planning, and money management. Include initiatives for credit
						repair and homeownership education, and support small business
						development via business planning assistance and access to
						microloans.
					</p>
					<img src={imgVII} alt='Our Focus' className='w-full rounded-[30px]' />
				</div>
				<div className='space-y-5'>
					<h5 className='text-4xl/[78px] font-nedium tracking-[-3px]'>
						Life Skills and Community Support
					</h5>
					<p>
						Offer life coaching and mentorship services to support personal
						development and goal achievement. Provide after-school mentorship
						for at-risk youth, and conduct family and parenting support
						workshops focusing on effective parenting and child development.
						Facilitate referrals and support services for survivors of domestic
						violence and abuse.
					</p>
					<img
						src={imgVIII}
						alt='Our Focus'
						className='w-full rounded-[30px]'
					/>
				</div>
				<div className='space-y-5'>
					<h5 className='text-4xl/[78px] font-nedium tracking-[-3px]'>
						Community Outreach and Advocacy
					</h5>
					<p>
						Educate communities about their rights and available resources
						through public awareness campaigns. Empower citizens via civic
						engagement and advocacy training to enable active participation in
						policy discussions. Coordinate neighborhood support programs in
						partnership with local organizations to conduct food drives,
						distribute school supplies, and organize community-based giving
						events.
					</p>
					<img src={imgIX} alt='Our Focus' className='w-full rounded-[30px]' />
				</div>
			</div>
		</section>
	);
};
export default FocusScope;
